<template>
  <vs-table hover-flat v-if="records && records.length" :data="records">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('phone_number')"></vs-th>
      <vs-th v-text="$t('extension_number')"></vs-th>
      <vs-th v-text="$t('caller_id')"></vs-th>
      <vs-th v-text="$t('hangup_time')"></vs-th>
      <vs-th v-text="$t('date')"></vs-th>
      <vs-th v-text="$t('time')"></vs-th>
      <vs-th v-text="$t('status')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.phone_number" :data-tr-title="$t('phone_number')"></vs-td>
        <vs-td v-text="tr.extension_number" :data-tr-title="$t('extension_number')"></vs-td>
        <vs-td v-text="tr.caller_id" :data-tr-title="$t('caller_id')"></vs-td>
        <vs-td v-text="tr.hangup_time" :data-tr-title="$t('hangup_time')"></vs-td>
        <vs-td v-text="tr.date" :data-tr-title="$t('date')"></vs-td>
        <vs-td v-text="tr.time" :data-tr-title="$t('time')"></vs-td>
        <vs-td :data-tr-title="$t('status')">
          <span :class="`auto-call-system-badge badge-${tr.status.toLowerCase().replace(' ', '-')}`" v-text="$t(`auto_call_system_${tr.status.toLowerCase().replace(' ', '_')}`)" />
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.AutoCallSystemPublic.List',
  props: {
    records: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>
.auto-call-system-badge {
  display: inline-block;
  padding: 5px;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  margin: 0px;
}

.auto-call-system-badge.badge-ready {
  color: #212529;
  background-color: #f8f9fa;
}
.auto-call-system-badge.badge-on-going {
  color: #fff;
  background-color: #007bff;
}
.auto-call-system-badge.badge-block {
  color: #fff;
  background-color: #343a40;
}
.auto-call-system-badge.badge-dropcall {
  color: #fff;
  background-color: #dc3545;
}
.auto-call-system-badge.badge-machine {
  color: #fff;
  background-color: #17a2b8;
}
.auto-call-system-badge.badge-busy {
  color: #212529;
  background-color: #ffc107;
}
.auto-call-system-badge.badge-listenhangup {
  color: #fff;
  background-color: #6c757d;
}
.auto-call-system-badge.badge-success {
  color: #fff;
  background-color: #28a745;
}
</style>
